import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';
import {fieldsSummary, panelsSummary} from './saveSummaries';

/**
 * «Guardar como plantilla nueva» (mockup, leyenda literal): nombre + compartir con el equipo.
 * `onConfirm({name, is_shared})`.
 */
export function SaveTemplateModal({isOpen, toggle, template, saving, onConfirm}) {
    const {t} = useTranslation();
    const [name, setName] = useState('');
    const [shared, setShared] = useState(true);

    useEffect(() => {
        if (!isOpen) return;
        setName(template && template.name ? t('informes.template.copy_of', {name: template.name, interpolation: {escapeValue: false}, defaultValue: 'Copia de {{name}}'}) : '');
        setShared(true);
    }, [isOpen, template, t]);

    const canConfirm = name.trim().length > 0 && !saving;
    const confirm = () => { if (canConfirm) onConfirm({name: name.trim(), is_shared: shared}); };

    return (
        <Modal isOpen={isOpen} toggle={toggle} className="inf-template-modal" data-testid="save-template-modal">
            <ModalHeader toggle={toggle}>{t('informes.template.save_as_new', 'Guardar como plantilla nueva')}</ModalHeader>
            <ModalBody>
                <div className="modal-section inf-save">
                    <p className="inf-modal-lead">{t('informes.template.save_as_new_lead', 'La plantilla guarda las métricas y dimensiones y los gráficos de esta hoja — nunca el cliente, las cuentas, el período ni los filtros. Sirve para cualquier informe.')}</p>
                    <div className="form-row">
                        <label htmlFor="inf-template-name">{t('informes.template.name', 'Nombre de la plantilla')}</label>
                        <input id="inf-template-name" type="text" className="form-control" value={name} autoFocus
                               onChange={(e) => setName(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') confirm(); }}/>
                    </div>
                    <div className="inf-sec-box -template">
                        <div className="inf-save-row"><h5>{t('informes.fields.title', 'Métricas y dimensiones')}</h5><p>{fieldsSummary(template, t)}</p></div>
                        <div className="inf-save-row"><h5>{t('informes.save.panels_row', 'Gráficos, métricas y textos')}</h5><p>{panelsSummary(template, t)}</p></div>
                    </div>
                    <label className="inf-check">
                        <input type="checkbox" checked={shared} onChange={(e) => setShared(e.target.checked)}/>
                        <span>{t('informes.template.share_with_team', 'Compartir con el equipo de la agencia')}</span>
                    </label>
                </div>
            </ModalBody>
            <ModalFooter>
                <button type="button" className="btn -alt -negative" onClick={toggle} disabled={saving}>{t('common.cancel', 'Cancelar')}</button>
                <button type="button" className="btn -alt" onClick={confirm} disabled={!canConfirm} data-testid="confirm-save-template">
                    {saving ? t('common.saving', 'Guardando…') : t('informes.template.save', 'Guardar plantilla')}
                </button>
            </ModalFooter>
        </Modal>
    );
}
